import { TravelTypes } from '../constants';

/*
When any changes update it in backend as well
D:\TravelWits\cruises_backend\TripServices\Entities\Trip.cs CheckIsPaymentRequiredForItinerary()
*/
const checkIsPaymentRequiredForItinerary = (itinerary) =>
  !itinerary ||
  (itinerary.cost || {}).doShowMarkupAmount ||
  (itinerary.mode === TravelTypes.carrental && itinerary.priceInfo.isPaymentRequired) ||
  (itinerary.mode === TravelTypes.hotel &&
    itinerary.selectedProduct &&
    itinerary.selectedProduct.isPaymentRequired) ||
  (itinerary.mode !== TravelTypes.hotel && itinerary.mode !== TravelTypes.carrental);

export default checkIsPaymentRequiredForItinerary;
